module.exports = __webpack_public_path__ + "img/icon-sb-hand-truck-boutique-48.97d4dfb.svg";